import { useEffect } from 'react';

const SITE_URL = 'https://artaestheticsskincare.com';
const DEFAULT_OG_IMAGE = `${SITE_URL}/gallery/art-wall-sign.jpg`;

const upsertMetaTag = (selector, attr, key, value) => {
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', value);
};

const upsertLinkTag = (selector, rel, href) => {
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = document.createElement('link');
    tag.setAttribute('rel', rel);
    document.head.appendChild(tag);
  }
  tag.setAttribute('href', href);
};

const SEO = ({
  title,
  description,
  path = '/',
  image = DEFAULT_OG_IMAGE,
  type = 'website',
  robots = 'index, follow',
  jsonLd
}) => {
  useEffect(() => {
    const canonicalUrl = `${SITE_URL}${path}`;

    document.title = title;

    upsertMetaTag('meta[name="description"]', 'name', 'description', description);
    upsertMetaTag('meta[name="robots"]', 'name', 'robots', robots);
    upsertMetaTag('meta[property="og:title"]', 'property', 'og:title', title);
    upsertMetaTag('meta[property="og:description"]', 'property', 'og:description', description);
    upsertMetaTag('meta[property="og:url"]', 'property', 'og:url', canonicalUrl);
    upsertMetaTag('meta[property="og:type"]', 'property', 'og:type', type);
    upsertMetaTag('meta[property="og:image"]', 'property', 'og:image', image);
    upsertMetaTag('meta[property="og:image:alt"]', 'property', 'og:image:alt', 'ART Aesthetics & Skincare clinic');
    upsertMetaTag('meta[property="og:site_name"]', 'property', 'og:site_name', 'ART Aesthetics & Skincare');
    upsertMetaTag('meta[name="twitter:card"]', 'name', 'twitter:card', 'summary_large_image');
    upsertMetaTag('meta[name="twitter:title"]', 'name', 'twitter:title', title);
    upsertMetaTag('meta[name="twitter:description"]', 'name', 'twitter:description', description);
    upsertMetaTag('meta[name="twitter:image"]', 'name', 'twitter:image', image);
    upsertMetaTag('meta[name="twitter:url"]', 'name', 'twitter:url', canonicalUrl);
    upsertLinkTag('link[rel="canonical"]', 'canonical', canonicalUrl);

    const scriptId = 'page-jsonld';
    const existingScript = document.getElementById(scriptId);
    if (existingScript) {
      existingScript.remove();
    }

    if (jsonLd) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = scriptId;
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }

    return () => {
      const script = document.getElementById(scriptId);
      if (script) {
        script.remove();
      }
    };
  }, [title, description, path, image, type, robots, jsonLd]);

  return null;
};

export default SEO;